import { lazy } from "react";
import { RouteObject, Navigate } from "react-router-dom";
import { ProtectedRoute } from "../components/feature/ProtectedRoute";
import { Suspense } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const RestaurantsPage = lazy(() => import("../pages/restaurants/page"));
const ConnexionPage = lazy(() => import("../pages/connexion/page"));
const DashboardLivreurPage = lazy(() => import("../pages/dashboard/livreur/page"));
const DashboardRestaurateurPage = lazy(() => import("../pages/dashboard/restaurateur/page"));
const DashboardCommercantPage = lazy(() => import("../pages/dashboard/commercant/page"));
const DashboardUtilisateurPage = lazy(() => import("../pages/dashboard/utilisateur/page"));
const AdminPage = lazy(() => import("../pages/admin/page"));
const DevenirLivreurPage = lazy(() => import("../pages/livreur/page"));
const DevenirPartenairePage = lazy(() => import("../pages/partenaire/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));
const AdminDashboard = lazy(() => import("../pages/dashboard/admin/page"));
const AdminDashboardPage = lazy(() => import('../pages/dashboard/admin/page'));
const AdminUsersPage = lazy(() => import('../pages/dashboard/admin/users/page'));
const AdminRestaurantsPage = lazy(() => import('../pages/dashboard/admin/restaurants/page'));
const AdminMenusPage = lazy(() => import('../pages/dashboard/admin/menus/page'));
const AdminOrdersPage = lazy(() => import('../pages/dashboard/admin/orders/page'));
const AdminDriversPage = lazy(() => import('../pages/dashboard/admin/drivers/page'));
const AdminCandidaturesPage = lazy(() => import('../pages/dashboard/admin/candidatures/page'));
const AdminPaymentsPage = lazy(() => import('../pages/dashboard/admin/payments/page'));
const AdminCitiesPage = lazy(() => import('../pages/dashboard/admin/cities/page'));
const AdminPromotionsPage = lazy(() => import('../pages/dashboard/admin/promotions/page'));
const AdminSupportPage = lazy(() => import('../pages/dashboard/admin/support/page'));
const AdminAnalyticsPage = lazy(() => import('../pages/dashboard/admin/analytics/page'));
const AdminRestaurantDetailPage = lazy(() => import('../pages/dashboard/admin/restaurants/detail/page'));
const UtilisateurDashboardPage = lazy(() => import('../pages/dashboard/utilisateur/page'));
const AdminPayments = lazy(() => import('../pages/dashboard/admin/payments/page'));
const BoutiquesPage = lazy(() => import('../pages/boutiques/page'));
const CommanderPage = lazy(() => import('../pages/commander/page'));
const AProposPage = lazy(() => import('../pages/a-propos/page'));
const SuiviCommandePage = lazy(() => import('../pages/suivi-commande/page'));
const ProfilPage = lazy(() => import('../pages/profil/page'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/restaurants",
    element: <RestaurantsPage />,
  },
  {
    path: "/boutiques",
    element: <BoutiquesPage />,
  },
  {
    path: "/commander",
    element: <CommanderPage />,
  },
  {
    path: "/a-propos",
    element: <AProposPage />,
  },
  {
    path: "/suivi-commande",
    element: <SuiviCommandePage />,
  },
  {
    path: "/profil",
    element: <ProfilPage />,
  },
  {
    path: "/connexion",
    element: <ConnexionPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/livraison",
    element: <DevenirLivreurPage />,
  },
  {
    path: "/livreur",
    element: <DevenirLivreurPage />,
  },
  {
    path: "/partenaire",
    element: <DevenirPartenairePage />,
  },
  {
    path: "/dashboard/livreur",
    element: (
      <ProtectedRoute requiredRole="livreur">
        <DashboardLivreurPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/restaurateur",
    element: (
      <ProtectedRoute requiredRole="restaurateur">
        <DashboardRestaurateurPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/commercant",
    element: (
      <ProtectedRoute requiredRole="commercant">
        <DashboardCommercantPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/utilisateur",
    element: (
      <ProtectedRoute requiredRole="client">
        <DashboardUtilisateurPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/admin",
    element: <ProtectedRoute><AdminDashboardPage /></ProtectedRoute>
  },
  {
    path: "/dashboard/admin/users",
    element: <ProtectedRoute><AdminUsersPage /></ProtectedRoute>
  },
  {
    path: "/dashboard/admin/restaurants",
    element: <ProtectedRoute><AdminRestaurantsPage /></ProtectedRoute>
  },
  {
    path: "/dashboard/admin/restaurants/:id",
    element: <ProtectedRoute><AdminRestaurantDetailPage /></ProtectedRoute>
  },
  {
    path: "/dashboard/admin/menus",
    element: <ProtectedRoute><AdminMenusPage /></ProtectedRoute>
  },
  {
    path: "/dashboard/admin/orders",
    element: <ProtectedRoute><AdminOrdersPage /></ProtectedRoute>
  },
  {
    path: "/dashboard/admin/drivers",
    element: <ProtectedRoute><AdminDriversPage /></ProtectedRoute>
  },
  {
    path: "/dashboard/admin/candidatures",
    element: <ProtectedRoute><AdminCandidaturesPage /></ProtectedRoute>
  },
  {
    path: "/dashboard/admin/payments",
    element: <ProtectedRoute><AdminPaymentsPage /></ProtectedRoute>
  },
  {
    path: "/dashboard/admin/cities",
    element: <ProtectedRoute><AdminCitiesPage /></ProtectedRoute>
  },
  {
    path: "/dashboard/admin/promotions",
    element: <ProtectedRoute><AdminPromotionsPage /></ProtectedRoute>
  },
  {
    path: '/dashboard/admin/support',
    element: <ProtectedRoute><AdminSupportPage /></ProtectedRoute>,
  },
  {
    path: '/dashboard/admin/analytics',
    element: <ProtectedRoute><AdminAnalyticsPage /></ProtectedRoute>,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;